import { h } from 'preact';

const Cross = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 32 33"
		width="32"
		height="33"
		xmlSpace="preserve"
	>
		<path
			fill="currentColor"
			d="M29.7 14L29.7 19 19.2 19 19.2 30.7 13.5 30.7 13.5 19 2.9 19 2.9 14 13.5 14 13.5 2.4 19.2 2.4 19.2 14z"
		/>
	</svg>
);

export default Cross;
